'use strict';

// import QRCode from 'qrcode';

/**
 * Gift Card Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Gift Card template.
 */

var selectors = {
  qrCodeCanvas: '[data-gift-card-qr]',
  printButton: '[data-gift-card-print]',
  giftCardCode: '[data-gift-card-digits]'
};

// This is the QR code that allows customers to use at a POS
document.querySelectorAll(selectors.qrCodeCanvas).forEach(function (element) {
  QRCode.toCanvas(element, element.dataset.identifier);
});

document.querySelectorAll(selectors.printButton).forEach(function (element) {
  element.addEventListener('click', function () {
    window.print();
  });
});

// Auto-select gift card code on click, based on ID passed to the function
document.querySelectorAll(selectors.giftCardCode).forEach(function (element) {
  element.addEventListener('click', function (evt) {
    var selection = window.getSelection();
    var range = document.createRange();
    range.selectNodeContents(evt.target);
    selection.removeAllRanges();
    selection.addRange(range);
  });
});